import { SequenceScheduleDaysModeEnum } from '../../../../../store/rtk-query/apis/sequence/enums/sequence-schedule-mode.enum';

export const DEFAULT_SCHEDULE_TIME = '10:32';
export const DEFAULT_SCHEDULE_DAYS_TYPE = SequenceScheduleDaysModeEnum.BusinessDays;
